
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import {
  Lavorazione,
  StatoLavorazione,
  VariazioneLavorazione,
  Azione
} from '@/models';
import { store, StoreActions } from '@/store';
import dayjs from 'dayjs';

@Component
export default class WorkflowLavorazione extends Vue {
  //@Prop() private idOrdine!: string;

  get loading() {
    return store.state.loading;
  }

  get ordine(): Lavorazione | undefined {
    return store.state.lavorazioneCorrente;
  }

  get azioniPossibili(): string[] {
    return store.state.uiLavorazione.azioni;
  }

  public azioni = Azione;

  get ordineAccettabile(): boolean {
    return store.state.uiLavorazione.azioni.includes(Azione.ACCETTA);
  }

  get variazioneDataConsegnaConsentita(): boolean {
    return store.state.uiLavorazione.azioni.includes(
      Azione.RICHIEDI_VARIAZIONE
    );
  }

  get statoLavorazione(): number {
    let stato = 1;

    if (store.state.lavorazioneCorrente) {
      switch (store.state.lavorazioneCorrente.stato) {
        case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE:
        case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_BC:
          stato = 1;
          break;
        case StatoLavorazione.ACCETTATO_IN_ATTESA_DI_CONSEGNA_A_FORNITORE:
        case StatoLavorazione.CONSEGNATO_A_FORNITORE:
        case StatoLavorazione.CONSEGNA_A_FORNITORE_PROCESSATA:
        case StatoLavorazione.IN_CORSO_DI_LAVORAZIONE:
          stato = 2;
          break;
        case StatoLavorazione.COMPLETATO_IN_ATTESA_DI_RIENTRO:
        case StatoLavorazione.RIENTRATO:
          stato = 3;
          break;
        case StatoLavorazione.RIENTRO_PROCESSATO:
          stato = 4; // CHIUSO
          break;
      }
    }

    return stato;
  }
  set statoLavorazione(value: number) {
    // NO-OP
  }

  // gestione negoziazione data

  date: string = '';
  dateFormatted: string = '';
  menu1 = false;

  get computedDateFormatted() {
    return this.formatDate(this.date);
  }

  @Watch('date')
  onDateChange(): void {
    this.dateFormatted = this.formatDate(this.date);
  }

  formatIsoDate(date: string): string {
    if (!date) return '';

    return dayjs(date).format('DD/MM/YYYY');
  }

  formatDate(date: string): string {
    if (!date) return '';

    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  }

  parseDate(date: string): string {
    if (!date) return '';

    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  //#region Azioni NEGOZIAZIONE

  @Emit('azione-inviata')
  async invioForzaAccettazioneParteBc() {
    if (store.state.lavorazioneCorrente) {
      await store.dispatch(
        StoreActions.ForzaAccettazioneParteBc,
        store.state.lavorazioneCorrente.id
      );
    }
  }

  @Emit('azione-inviata')
  async invioRichiestaVariazione() {
    // validazione data...
    // TODO

    if (store.state.lavorazioneCorrente) {
      let variazione: VariazioneLavorazione = {
        variazioneDataConsegnaProposta: dayjs(this.date).toISOString()
      };

      await store.dispatch(StoreActions.RichiediVariazioneLavorazione, {
        id: store.state.lavorazioneCorrente.id,
        variazione: variazione
      });
    }
  }

  @Emit('azione-inviata')
  async invioAccettazione() {
    if (store.state.lavorazioneCorrente) {
      await store.dispatch(
        StoreActions.AccettaLavorazione,
        store.state.lavorazioneCorrente.id
      );
    }
  }

  //#endregion Azione NEGOZIAZIONE

  //#region Azioni LAVORAZIONE

  @Emit('azione-inviata')
  async invioForzaConsegnaFornitoreBc() {
    if (store.state.lavorazioneCorrente) {
      await store.dispatch(
        StoreActions.ForzaConsegnaFornitoreBc,
        store.state.lavorazioneCorrente.id
      );
    }
  }

  @Emit('azione-inviata')
  async invioConsegnaAFornitore() {
    if (store.state.lavorazioneCorrente) {
      await store.dispatch(
        StoreActions.ConsegnaFornitore,
        store.state.lavorazioneCorrente.id
      );
    }
  }

  @Emit('azione-inviata')
  async invioConfermaConsegna() {
    if (store.state.lavorazioneCorrente) {
      await store.dispatch(
        StoreActions.ConfermaConsegna,
        store.state.lavorazioneCorrente.id
      );
    }
  }

  @Emit('azione-inviata')
  async invioInizioLavorazione() {
    if (store.state.lavorazioneCorrente) {
      await store.dispatch(
        StoreActions.InizioLavorazione,
        store.state.lavorazioneCorrente.id
      );
    }
  }

  @Emit('azione-inviata')
  async invioCompletaLavorazione() {
    if (store.state.lavorazioneCorrente) {
      await store.dispatch(
        StoreActions.CompletaLavorazione,
        store.state.lavorazioneCorrente.id
      );
    }
  }

  //#endregion Azioni LAVORAZIONE

  //#region Azioni COMPLETAMENTO
  @Emit('azione-inviata')
  async invioRiconsegnaABc() {
    if (store.state.lavorazioneCorrente) {
      await store.dispatch(
        StoreActions.RiconsegnaABc,
        store.state.lavorazioneCorrente.id
      );
    }
  }

  @Emit('azione-inviata')
  async invioRegistraRientro() {
    if (store.state.lavorazioneCorrente) {
      await store.dispatch(
        StoreActions.RegistraRientro,
        store.state.lavorazioneCorrente.id
      );
    }
  }
  //#endregion
}
